export const OTP_LENGTH = 6;

// The backend states no resend limit of its own; Kong rate-limits the endpoint and answers 429.
// This cooldown exists to keep an investor from walking into that 429, not as a control.
export const OTP_RESEND_COOLDOWN_SECONDS = 30;

export const OTP_SENT_AT_STORAGE_KEY = 'glomo.investorPortal.otpSentAt';
